<footer class="bg-gray-900 text-white">
  <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      <!-- Company Info Widget -->
      <div class="col-span-1">
        <div class="single-footer-widget">
          <a routerLink="/" class="block mb-4">
            <img src="assets/img/white-logo.png" alt="Insightful IT Services" class="h-10">
          </a>
          <p class="text-gray-300 mb-4">
            Leading provider of enterprise-grade cloud infrastructure solutions in India with 99.99% uptime SLA and 24/7 expert support.
          </p>
          <div class="flex space-x-4 mb-3">
            <a href="https://www.facebook.com/InsightfulITS" target="_blank" aria-label="Facebook" class="text-[#1877F2] hover:text-[#1877F2]/80 transition-colors duration-200">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://x.com/insightfulits" target="_blank" aria-label="X (formerly Twitter)" class="text-gray-300 hover:text-white transition-colors duration-200 text-lg">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="inline-block">
                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z"/>
              </svg>
            </a>
            <a href="https://www.instagram.com/insightfulits/" target="_blank" aria-label="Instagram" class="text-[#E4405F] hover:text-[#E4405F]/80 transition-colors duration-200">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/insightful-it-services/" target="_blank" aria-label="LinkedIn" class="text-[#0077B5] hover:text-[#0077B5]/80 transition-colors duration-200">
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a href="https://www.youtube.com/@InsightfulITS" target="_blank" aria-label="YouTube" class="text-[#FF0000] hover:text-[#FF0000]/80 transition-colors duration-200">
              <i class="fab fa-youtube"></i>
            </a>
          </div>
          <app-visitor-counter></app-visitor-counter>
        </div>
      </div>

      <!-- Services Widget -->
      <div class="col-span-1">
        <div class="single-footer-widget">
          <h3 class="text-lg font-semibold mb-4">Services</h3>
          <ul class="space-y-2">
            <li>
              <a routerLink="/gpu-cloud" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> GPU Cloud
              </a>
            </li>
            <li>
              <a routerLink="/windows-cloud" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> Windows Cloud
              </a>
            </li>
            <li>
              <a routerLink="/linux-cloud" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> Linux Cloud
              </a>
            </li>
            <li>
              <a routerLink="/storage-cloud" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> Storage Cloud
              </a>
            </li>
            <li>
              <a routerLink="/pricing" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> All Services
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Quick Links Widget -->
      <div class="col-span-1">
        <div class="single-footer-widget">
          <h3 class="text-lg font-semibold mb-4">Quick Links</h3>
          <ul class="space-y-2">
            <li>
              <a routerLink="/" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> Home
              </a>
            </li>
            <li>
              <a routerLink="/about" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> About Us
              </a>
            </li>
            <li>
              <a routerLink="/pricing" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> Pricing
              </a>
            </li>
            <li>
              <a routerLink="/data-centers" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> Data Centers
              </a>
            </li>
            <li>
              <a routerLink="/contact" class="text-gray-300 hover:text-white transition-colors duration-200 flex items-center">
                <i class="bx bx-chevron-right mr-2"></i> Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Contact Info Widget -->
      <div class="col-span-1">
        <div class="single-footer-widget">
          <h3 class="text-lg font-semibold mb-4">Contact Info</h3>
          <div class="space-y-4">
            <div class="flex items-start">
              <i class="bx bx-map text-primary-500 text-xl mr-3 mt-1"></i>
              <div>
                <h4 class="text-sm font-medium text-gray-300">Datacenter Location</h4>
                <p class="text-gray-300">Mumbai & Noida, India</p>
              </div>
            </div>
            <div class="flex items-start">
              <i class="bx bx-phone text-primary-500 text-xl mr-3 mt-1"></i>
              <div>
                <h4 class="text-sm font-medium text-gray-300">Phone</h4>
                <a href="tel:+919167663638" class="text-gray-300 hover:text-white transition-colors duration-200">+91 9167663638</a>
              </div>
            </div>
            <div class="flex items-start">
              <i class="bx bx-envelope text-primary-500 text-xl mr-3 mt-1"></i>
              <div>
                <h4 class="text-sm font-medium text-gray-300">Email</h4>
                <a href="mailto:info@insightfulitservices.com" class="text-gray-300 hover:text-white transition-colors duration-200">info@insightfulitservices.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Newsletter Section -->
    <!-- <div class="mt-12 pt-8 border-t border-gray-800">
      <app-newsletter></app-newsletter>
    </div> -->

    <!-- Footer Bottom -->
    <div class="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
      <p class="text-gray-400 text-sm">
        © <span id="currentYear">{{ getCurrentYear() }}</span> Insightful IT Services LLP. All Rights Reserved.
      </p>
      <div class="mt-4 md:mt-0 flex space-x-6">
        <a routerLink="/terms-conditions" class="text-gray-400 hover:text-white text-sm transition-colors duration-200">Terms & Conditions</a>
        <a routerLink="/privacy-policy" class="text-gray-400 hover:text-white text-sm transition-colors duration-200">Privacy Policy</a>
      </div>
    </div>
  </div>

  <!-- Scroll to Top Button -->
  <button (click)="scrollToTop()" class="go-top fixed bottom-8 right-8 w-12 h-12 bg-primary-600 text-white rounded-full shadow-lg flex items-center justify-center opacity-0 invisible transition-all duration-300 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
    <i class="bx bx-chevron-up text-xl"></i>
  </button>
</footer>